const sortImageList = (list) =>
  [...list].sort((a, b) => {
    if (Boolean(a.is_primary) !== Boolean(b.is_primary)) return a.is_primary ? -1 : 1;
    return (Number(a.display_order) || 0) - (Number(b.display_order) || 0);
  });

/**
 * When a color is selected: show only images tagged with that color (color_id match).
 * If none are tagged for that color, fall back to “all colors” shots (no color_id), then the full gallery.
 * When no color is selected, return the full list.
 */
export function getImagesForColor(images, selectedColor) {
  const all = images || [];
  if (selectedColor == null || all.length === 0) return all;

  const specific = all.filter(
    (img) => img.color_id != null && Number(img.color_id) === Number(selectedColor)
  );
  if (specific.length > 0) {
    return sortImageList(specific);
  }

  const neutral = all.filter((img) => img.color_id == null);
  if (neutral.length > 0) {
    return sortImageList(neutral);
  }

  return all;
}

export function getPrimaryImageForColor(images, selectedColor, fallbackUrl) {
  const list = getImagesForColor(images, selectedColor);
  const url = list[0]?.image_url;
  if (url) return url;
  return fallbackUrl || '/placeholder.png';
}

/** First image explicitly tagged to this color (for variation swatches). No neutral/full-gallery fallback. */
export function getColorTaggedImage(images, colorId) {
  const all = images || [];
  if (colorId == null || all.length === 0) return null;
  const specific = all.filter(
    (img) => img.color_id != null && Number(img.color_id) === Number(colorId)
  );
  if (specific.length === 0) return null;
  return sortImageList(specific)[0]?.image_url || null;
}
